import React, { useState } from 'react';
import { Calendar, Wrench, List, GasPump, Users, Drop, Disc } from '@phosphor-icons/react';
import PojazdyListTab from './PojazdyListTab';
import TerminyTab from './TerminyTab';
import NaprawyTab from './NaprawyTab';
import TankowaniaTab from './TankowaniaTab';
import TankowaniaPracownikowTab from './TankowaniaPracownikowTab';
import WymianaOlejuTab from './WymianaOlejuTab';
import OponyTab from '../shared/OponyTab';

export default function PojazdyTab() {
  const [subTab, setSubTab] = useState('lista');

  const btnClass = (active, color) =>
    `py-2 sm:py-3 px-3 sm:px-6 text-xs sm:text-sm font-semibold border-b-2 -mb-px transition-colors whitespace-nowrap ${
      active ? `${color}` : 'border-transparent text-gray-600 hover:text-gray-900'
    }`;

  return (
    <div>
      {/* Sub-tab Switcher — mobile-scrollable */}
      <div className="mb-4 sm:mb-6 flex gap-1 sm:gap-2 border-b border-gray-200 overflow-x-auto">
        <button onClick={() => setSubTab('lista')} className={btnClass(subTab === 'lista', 'border-green-600 text-green-600')}>
          <List className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Lista
        </button>
        <button onClick={() => setSubTab('terminy')} className={btnClass(subTab === 'terminy', 'border-blue-600 text-foreground')}>
          <Calendar className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Terminy
        </button>
        <button onClick={() => setSubTab('naprawy')} className={btnClass(subTab === 'naprawy', 'border-orange-600 text-orange-600')}>
          <Wrench className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Naprawy
        </button>
        <button
          onClick={() => setSubTab('wymiana-oleju')}
          data-testid="pojazdy-subtab-wymiana-oleju"
          className={btnClass(subTab === 'wymiana-oleju', 'border-amber-600 text-amber-600')}
        >
          <Drop className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Wymiana oleju
        </button>
        <button
          onClick={() => setSubTab('opony')}
          data-testid="pojazdy-subtab-opony"
          className={btnClass(subTab === 'opony', 'border-slate-800 text-slate-800')}
        >
          <Disc className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Opony
        </button>
        <button
          onClick={() => setSubTab('tankowania')}
          data-testid="pojazdy-subtab-tankowania"
          className={btnClass(subTab === 'tankowania', 'border-amber-600 text-amber-600')}
        >
          <GasPump className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Tankowania
        </button>
        <button
          onClick={() => setSubTab('tankowania-pracownikow')}
          data-testid="pojazdy-subtab-tankowania-pracownikow"
          className={btnClass(subTab === 'tankowania-pracownikow', 'border-amber-700 text-amber-700')}
        >
          <Users className="w-4 h-4 sm:w-5 sm:h-5 inline mr-1 sm:mr-2" /> Tankowania pracowników
        </button>
      </div>

      {subTab === 'lista' && <PojazdyListTab />}
      {subTab === 'terminy' && <TerminyTab />}
      {subTab === 'naprawy' && <NaprawyTab />}
      {subTab === 'wymiana-oleju' && <WymianaOlejuTab />}
      {subTab === 'opony' && <OponyTab isAdmin />}
      {subTab === 'tankowania' && <TankowaniaTab />}
      {subTab === 'tankowania-pracownikow' && <TankowaniaPracownikowTab />}
    </div>
  );
}
